// Copyright (c) 2019 Deere & Company


import './index.scss';
import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import {
    convertToArray, convertToArrayProdSeries, defaultWorklistProperties, getUserEditedInputs,
} from '../../../claims/common';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
import {
    filterEmpty, isAlphanumeric,
} from '../../../shared/services/validator';
import {
    getAuditList, getBranch, getDefaultFactoryCode, getWorklistFactories,
} from '../../../app/common/repositories';
import Accordion from '../../../app/common/components/accordion';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
import CSVMultiSelect from '../../../shared/components/CSVMultiSelect';
import ClaimDetailsPanel from '../../../claim-details';

import InputWithFaIcon from '../../../shared/components/labeled-input-with-fa-icon';
import LabeledDateRangePicker from '../../../shared/components/labeled-date-picker/LabeledDateRangePicker';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import ProductSearch from '../../../claims/components/product-search';
import PropTypes from 'prop-types';
import SimpleMultipleEntryPopup from '../../../shared/components/simple-multiplentry-popup';
import WorkListResultPanel from '../worklist-result-panel';
import { cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { customizeErrorAlert } from '../../../shared/services/customize-error-alert-bar';
import { getWorklistSearchData } from '../../repositories';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';
import WorklistUploadPopup from "../worklist-result-panel/worklist-upload-popup";


/* hard code values for Audit Code */
// const auditCode = [{ auditCode: '0201', auditMessage: 'No Function Code Assigned' },
//     { auditCode: '0202', auditMessage: 'No Design Code Assigned' },
// ];

class Worklist extends Component {

    state = {
        factories: [],
        workListData: {},
        isWorkListSearch: false,
        selectedWarrantyClaimID: 0,
        gridAPI: {},
        workListCount: {
            basicSrcInpsCount: 0,
            prdSrcInpsCount: 0,
        },
        claimDetailsInfo: {
            totalClaims: 0,
            displayedClaimIndex: 0,
        },
        branchList: [],
        branchDropdownList: {},
        selectedBranchValue: null,
        auditCodeList: [],
        defaultProperties: {},
        isPopupOpen: false,
        isValidEntry: true,
        popupName: '',
        popupPropertyName: '',
        popupPropertyValue: '',
        productSeriesList: [],
        modifiedSearch: [],
        selectedClaimNumber: 0,
        searchInputs: cloneDeep( defaultWorklistProperties ),

        modelIsOpen: false,
        modelIsClose: false,
    }

    getSearchedLabels = {
        factoryCode: 'Factory Code',
        claimNumbers: 'Claim Number',
        pins: 'PIN Number',
        partNumber: 'Part Number',
        processDate: 'Process Date',
        buildDate: 'Build Date',
        productSeriesIds: 'Product Series',
        productSubSeriesIds: 'Product Sub Series',
        baseCodeIds: 'Product BaseCode',
        branchIds: 'Branch',
        auditCode: 'Audit Code',
    }


    basicSrcInps = [
        'factoryCode',
        'claimNumbers',
        'pins',
        'pipNumbers',
        'partNumber',
        'processDate',
        'buildDate',
        'buildMonth',
        'serialNumber',
        'auditCode',
        'branchIds',

    ];

    ProdSrcInps = [
        'productSeriesIds',
        'productSubSeriesIds',
        'baseCodeIds',
    ];


    basicSearchInpsCount = 0;

    prdSearchInpsCount = 0;

    componentWillMount = () => {

        this.loadDefaults();

    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.reload === 'worklist' ) {

            this.onBackToResult();
            this.onNewSearch();
            nextProps.updateReload();

        }

    }

    getPreviousClaimDetails = () => {

        let claimIndex = this.state.claimDetailsInfo.displayedClaimIndex;

        for ( let i = claimIndex - 1; i >= 0; i -= 1 ) {

            const CurrentClaimId = this.state.gridAPI
                .getDisplayedRowAtIndex( claimIndex ).data.warrantyClaimId;
            const nextClaimId = this.state.gridAPI
                .getDisplayedRowAtIndex( i ).data.warrantyClaimId;

            if ( CurrentClaimId !== nextClaimId ) {

                claimIndex = i;
                break;

            } else {

                claimIndex -= 1;

            }

        }

        this.onClaimDetails( claimIndex );

    }

    onBackToResult = () => {

        this.setState( {
            isClaimDetails: false,
        } );

    }

    getNextClaimDetails = () => {

        let claimIndex = this.state.claimDetailsInfo.displayedClaimIndex;
        const totalClaims = this.state.gridAPI.getDisplayedRowCount();

        for ( let i = claimIndex + 1; i < totalClaims; i += 1 ) {

            const CurrentClaimId = this.state.gridAPI
                .getDisplayedRowAtIndex( claimIndex ).data.warrantyClaimId;
            const nextClaimId = this.state.gridAPI
                .getDisplayedRowAtIndex( i ).data.warrantyClaimId;

            if ( CurrentClaimId !== nextClaimId ) {

                claimIndex = i;
                break;

            } else {

                claimIndex += 1;

            }

        }

        this.onClaimDetails( claimIndex );

    }

    updateGridAPI = gridApi => {

        this.setState( {
            gridAPI: gridApi,
        } );

    }

    onClaimDetails = clickedRowIndex => {

        this.props.increaseCounter();
        const getClickedRowDetails = this.state.gridAPI.getDisplayedRowAtIndex( clickedRowIndex ),
            totalClaims = this.state.gridAPI.getDisplayedRowCount(),
            { warrantyClaimId } = getClickedRowDetails.data,
            { claimNumber } = getClickedRowDetails.data,
            updatedProps = cloneDeep( this.state.claimDetailsInfo );

        updatedProps.totalClaims = totalClaims;
        updatedProps.displayedClaimIndex = clickedRowIndex;

        this.setState( {
            claimDetailsInfo: updatedProps,
            selectedWarrantyClaimID: warrantyClaimId,
            selectedClaimNumber: claimNumber,
            isClaimDetails: true,

        } );

        this.props.decreaseCounter();

    }

    getComponentEditedInpsCount = modifiedInput => {

        modifiedInput.forEach( item => {

            if ( this.basicSrcInps.includes( item[0] ) ) this.basicSearchInpsCount += 1;
            else if ( this.ProdSrcInps.includes( item[0] ) ) this.prdSearchInpsCount += 1;

        } );

        this.updateCount( this.basicSearchInpsCount, this.prdSearchInpsCount );
        this.basicSearchInpsCount = 0;
        this.prdSearchInpsCount = 0;

    }

    updatedSrcInputs = modifiedInput => {


        this.setState( { modifiedSearch: modifiedInput } );

        this.getComponentEditedInpsCount( modifiedInput );

    };


    updateCount = ( basicSrcCount, prdSrcCount ) => {

        const updatedState = cloneDeep( this.state.workListCount );
        updatedState.basicSrcInpsCount = basicSrcCount;
        updatedState.prdSrcInpsCount = prdSrcCount;

        this.setState( {
            workListCount: updatedState,
        } );

    }

    loadDefaults = () => {

        this.branchDropdown();
        this.props.increaseCounter();
        getWorklistFactories().then( response => {

            const recFactories = [];
            response.forEach( factory => {

                recFactories.push( {
                    factoryCode: factory.factoryCode,
                    factoryDescription: `${factory.factoryCode} - ${factory.factoryDescription}`,
                } );

            } );

            let defaultFactory = getDefaultFactoryCode();
            const newSearchInputs = { ...this.state.searchInputs };
            this.setState( {
                factories: recFactories,
                defaultProperties: newSearchInputs,
            } );
            if ( defaultFactory === '' && recFactories.length > 0 ) defaultFactory = recFactories[0].factoryCode;
            this.handleFactoryCodeChange( defaultFactory );
            this.getAuditCodeList( defaultFactory );
            this.updatedSrcInputs( getUserEditedInputs( this.state.searchInputs, 'worklist' ) );
            this.getComponentEditedInpsCount( getUserEditedInputs( this.state.searchInputs, 'worklist' ) );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    // handleFactoryCodeChange = obj => {

    //     if ( obj ) {

    //         this.props.increaseCounter();
    //         getProductSeries( obj ).then( response => {

    //             this.setState( {
    //                 productSeriesList: response,

    //             } );
    //             this.props.decreaseCounter();

    //         } ).catch( () => {

    //             this.props.decreaseCounter();

    //         } );

    //     }

    // }

    handleFactoryCodeChange = id => {

        const updatedProps = cloneDeep( this.state.searchInputs );
        updatedProps.factoryCode = ( id === '-1' ) ? '' : id;
        this.setState( {
            searchInputs: updatedProps,
        } );

        this.updatedSrcInputs( getUserEditedInputs( updatedProps, 'worklist' ) );

    }


    accordionSecondaryText = () => (
        <span className="accordion-secondary-text caution">
            <span className="is-required red-font">*</span>
            Atleast One Criteria Must be Specifed
        </span>
    );

    updateFactoryCode = obj => {

        const selectedOption = {
            target: {
                name: 'factoryCode',
                value: obj,
            },
        };

        this.updateSearchInput( selectedOption );
        this.handleFactoryCodeChange( selectedOption.target.value );


    }

    handleAuditCode = obj => {

        const selectedOption = {
            target: {
                name: 'auditCode',
                value: obj,
            },
        };
        this.updateSearchInput( selectedOption );

    }


    getAuditCodeList = () => {

        this.props.increaseCounter();
        getAuditList().then( response => {

            const auditList = [];
            response.forEach( list => {

                auditList.push( {
                    auditCode: list.auditCode,
                    auditMessage: `${list.auditCode} - ${list.auditMessage}`,
                } );

            } );

            this.setState( {
                auditCodeList: auditList,
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    updateSearchInput = event => {

        const { name, value } = event.target;
        const validateVal = isAlphanumeric( value > 0 ? value : '' );
        if ( validateVal ) {

            const updatedProps = cloneDeep( this.state.searchInputs );
            updatedProps[name] = value;

            this.setState( {
                searchInputs: updatedProps,
            } );

            this.updatedSrcInputs( getUserEditedInputs( updatedProps, 'worklist' ) );

        }

    }

    // handleRangeChange = ( props, range, data ) => {

    //     const obj = { ...this.state.searchInputs[props.name] };
    //     if ( range === 'from' ) {

    //         obj[range] = data;

    //     } else if ( range === 'to' ) {

    //         obj[range] = data;

    //     } else {

    //         obj.from = data;
    //         obj.to = data;

    //     }
    //     this.setState( {
    //         [props.name]: obj,
    //     } );

    //     const selectedOption = {
    //         target: {
    //             name: props.name,
    //             value: obj,
    //         },
    //     };
    //     this.updateSearchInput( selectedOption );

    // }

    rangeFromAndTo = ( props, range, data ) => {

        const obj = { ...this.state.searchInputs[props.name] };
        if ( range === 'from' ) {

            obj[range] = data === null ? 0 : data;

        } else if ( range === 'to' ) {

            obj[range] = data === null ? 0 : data;

        } else {

            obj.from = data;
            obj.to = data;

        }
        return obj;

    }

    handleRangeChange = ( props, range, data ) => {

        let rangeObj = {};

        rangeObj = this.rangeFromAndTo( props, range, data );

        this.setState( {
            [props.name]: rangeObj,
        } );

        const selectedOption = {
            target: {
                name: props.name,
                value: rangeObj,
            },
        };
        this.updateSearchInput( selectedOption );

    }


    updateCurrentState = properties => {

        const updatedInputs = { ...this.state.searchInputs };
        Object.keys( properties ).forEach( key => {

            updatedInputs[key] = properties[key];

        } );
        this.setState( {
            searchInputs: updatedInputs,
        } );

        this.updatedSrcInputs( getUserEditedInputs( updatedInputs, 'worklist' ) );

    }

    updateMultiEntryInput = event => {

        const { name, value } = event.target;
        const updatedProps = cloneDeep( this.state.searchInputs );
        updatedProps[name] = value;

        this.setState( {
            searchInputs: updatedProps,
        } );

        this.updatedSrcInputs( getUserEditedInputs( updatedProps, 'worklist' ) );

    }

    branchDropdown = () => {

        this.props.increaseCounter();
        getBranch().then( response => {

            const BranchDropdownOptions = [];
            response.forEach( branchList => {

                BranchDropdownOptions.push( {
                    value: branchList.branchCode,
                    label: `${branchList.branchCode} - ${branchList.branchLocation}`,
                } );

            } );
            this.setState( {
                branchDropdownList: BranchDropdownOptions,
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    };


    handleBranchChange = selectedOption => {

        const selectedBranchValue = {
            target: {
                name: 'branchIds',
                value: selectedOption === null ? '' : selectedOption,
            },
        };
        this.updateSearchInput( selectedBranchValue );


    };


    validateMultiEntries = event => {

        const propertyName = event.target.name;
        const propertyValue = ( event.target.value ).trim();

        this.setState( {
            isValidEntry: true,
        } );

        if ( propertyName === 'partNumber' ) return this.validatePartNumber( propertyValue );
        if ( propertyName === 'claimNumbers' ) return this.validateClaimNumber( propertyValue );
        return this.validatePinOrPip( propertyValue );

    }


    onClosePopup = () => {

        this.setState( {
            isPopupOpen: false,

        } );

    }

    noOfEntries = entries => filterEmpty( entries ).length


    initiatePopup = ( propertyName, obj ) => {

        this.setState( {
            isPopupOpen: true,
            popupName: obj.currentTarget.className,
            popupPropertyName: propertyName,
            popupPropertyValue: this.state.searchInputs[propertyName],
        } );

    }

    valuesHavingSeparators = propertyVal => {

        const match = ( propertyVal ).search( ',' ) > 0 ? true : /\r|\n/.exec( propertyVal ) !== null;

        return match && this.noOfEntries( propertyVal ) > 1;

    }


    onEditSearch = () => {

        this.setState( {
            isWorkListSearch: false,
        } );

    }

    onNewSearch = () => {

        const newSearch = { ...this.state.defaultProperties };
        this.setState( {
            searchInputs: newSearch,
            modifiedSearch: [],
            isWorkListSearch: false,
        } );
        this.loadDefaults();

    }


    validateRange = range => {

        if ( ( range.from === 0 || range.from === null ) ||
            ( range.to === 0 || range.to === null ) ) return false;
        return true;

    }


    onSubmit = () => {

        let isValidEntry = true;
        const payLoad = cloneDeep( this.state.searchInputs );
        const mandatoryCheck = [
            'buildDate',
            'processDate',
        ];


        const manipulatePayloadProperty = [
            'pins',
            'partNumber',
            'claimNumbers',
        ];

        const mandatoryValidateProperty = [
            'pins',
            'claimNumbers',
            'buildDate',
            'processDate',
        ];
        const propertyToBeConvertToArray = [
            'productSubSeriesIds',
            'baseCodeIds',
            'branchIds',
        ];
        const prodSeriesToBeConvertToArray = [
            'productSeriesIds',
        ];

        propertyToBeConvertToArray.forEach( propertyName => {


            if ( propertyName === 'productSeriesIds' ) {

                payLoad.productSeriesIds = payLoad.productSeriesIds === '-1' ? '' : payLoad.productSeriesIds;

            }

            const propertyValue = payLoad[propertyName];

            payLoad[propertyName] = convertToArray( propertyValue );


        } );


        prodSeriesToBeConvertToArray.forEach( propertyName => {

            if ( propertyName === 'productSeriesIds' ) {

                payLoad.productSeriesIds = payLoad.productSeriesIds === '-1' ? '' : payLoad.productSeriesIds;

            }

            const propertyValue = payLoad[propertyName];


            payLoad[propertyName] = convertToArrayProdSeries( propertyValue );

        } );


        const errMsg = [];
        let anyMandatoryFieldsFilled = true;
        mandatoryValidateProperty.forEach( propertyName => {

            const propertyValue = payLoad[propertyName];

            if ( propertyValue !== '' ) {

                if ( ( propertyName === 'pins' || propertyName === 'pipNumbers' ) && isValidEntry ) {

                    anyMandatoryFieldsFilled = true;
                    if ( !this.validatePinOrPip( payLoad[propertyName] ) ) {

                        errMsg.push( `${this.getSearchedLabels[propertyName]} should be 13 or 17 digits` );
                        isValidEntry = false;
                        return isValidEntry;

                    }

                } else if ( propertyName === 'partNumber' && isValidEntry ) {

                    if ( !this.validatePartNumber( payLoad[propertyName] ) ) {

                        errMsg.push( `${this.getSearchedLabels[propertyName]} should be i2 digits` );
                        isValidEntry = false;
                        return isValidEntry;

                    }

                } else if ( propertyName === 'claimNumbers' && isValidEntry ) {

                    anyMandatoryFieldsFilled = true;
                    if ( !this.validateClaimNumber( payLoad[propertyName] ) ) {

                        errMsg.push( `${this.getSearchedLabels[propertyName]} should be 12 digits` );
                        isValidEntry = false;
                        return isValidEntry;

                    }

                } else if ( Array.isArray( propertyValue ) ) {

                    if ( propertyValue.length > 0 ) anyMandatoryFieldsFilled = true;

                } else if ( typeof ( propertyValue ) === 'object' && isValidEntry ) {

                    if ( ( propertyValue.from !== 0 &&
                        propertyValue.from !== null )
                        || ( propertyValue.to !== 0 && propertyValue.to !== null ) ) {

                        anyMandatoryFieldsFilled = true;
                        if ( !this.validateRange( payLoad[propertyName] ) ) {

                            errMsg.push( `${this.getSearchedLabels[propertyName]} should be in valid range` );
                            isValidEntry = false;
                            return isValidEntry;

                        }

                    }

                }

            }
            return false;

        } );

        payLoad.auditCode = payLoad.auditCode === '-1' ? '' : payLoad.auditCode;

        payLoad.factoryCode = payLoad.factoryCode === '-1' ? '' : payLoad.factoryCode;

        if ( payLoad.baseCodeIds.length > 0 ) {

            payLoad.productSubSeriesIds = [];

        }


        manipulatePayloadProperty.forEach( propertyName => {

            if ( payLoad[propertyName] !== '' ) {

                payLoad[propertyName] = filterEmpty( payLoad[propertyName] );

            } else payLoad[propertyName] = [];

        } );


        mandatoryCheck.forEach( element => {

            payLoad[element].from = payLoad[element].from > 0 ?
                new Date( payLoad[element].from ).getTime() / 1000 : 0;

            payLoad[element].to = payLoad[element].to > 0 ?
                new Date( payLoad[element].to ).getTime() / 1000 : 0;

        } );


        setTimeout( () => {

            if ( !anyMandatoryFieldsFilled ) {

                errMsg.push( 'Please fill any mandatory field' );

            }


            if ( !anyMandatoryFieldsFilled || !isValidEntry || !this.state.isValidEntry ) {

                errMsg.forEach( errMessage => {

                    customizeErrorAlert( errMessage );

                } );

            } else {


                this.props.increaseCounter();
                getWorklistSearchData( payLoad ).then( response => {

                    this.setState( {
                        isWorkListSearch: true,
                        workListData: response,
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        }, 500 );

    }

    multiEntryValidation = propertyValue => {

        const multiEntry = filterEmpty( propertyValue );
        let validEntry = true;
        multiEntry.forEach( num => {

            const numb = isAlphanumeric( num.trim() );
            if ( !numb ) validEntry = false;

            return validEntry;

        } );

        return validEntry;

    }

    validatePartNumber = propertyValue => {

        const partNumbers = filterEmpty( propertyValue );
        let validEntry = true;
        partNumbers.forEach( num => {

            const numb = isAlphanumeric( num );
            if ( validEntry && ( !numb || num.trim() === '' || ( num.trim() ).length > 12 ) ) {

                validEntry = false;
                return false;

            }
            return validEntry;

        } );

        // this.updateStatus( validEntry );
        return validEntry;

    }

    updateStatus = validEntry => {

        if ( this.state.isValidEntry ) {

            this.setState( {
                ...this.state,
                isValidEntry: validEntry,
            } );

        }

    }

    validatePinOrPip = propertyValue => {

        const pipOrPip = filterEmpty( propertyValue );
        let validEntry = true;
        pipOrPip.forEach( num => {

            const numb = isAlphanumeric( num );
            if ( validEntry && ( !numb || num.trim() === '' || ( ( num.trim() ).length !== 13 && ( num.trim() ).length !== 17 ) ) ) {

                validEntry = false;
                // return false;

            }

            return validEntry;

        } );

        // this.updateStatus( validEntry );
        return validEntry;

    }

    validateClaimNumber = propertyValue => {

        const claimNumbers = filterEmpty( propertyValue );
        let validEntry = true;
        const allowEmpty = false;
        claimNumbers.forEach( num => {

            const numb = isAlphanumeric( num, allowEmpty );
            if ( !numb || num.trim() === '' || ( num.trim() ).length > 12 ) {

                validEntry = false;
                return false;

            }
            return true;

        } );

        this.updateStatus( validEntry );
        return validEntry;

    }

    onUploadReport = () => {

        this.setState( {
            modelIsOpen: true,
        } );

    }

    onUploadReportClose = () => {

        this.setState( {
            modelIsOpen: false,
        } );

    };


    render () {

        const options = this.state.factories ? this.state.factories : [];
        const selectedValue = this.state.searchInputs.factoryCode ? this.state.searchInputs.factoryCode : '';
        return (
            <div>
                {!this.state.isWorkListSearch && (
                    <section>
                        <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                        <header>
                            <div>
                            <h2 className="page-header">
                                Worklist
                                <button className="primary-button" onClick={this.onSubmit} type="button"><span> Submit </span></button>
                                {/*<button className="primary-button" onClick={this.onUploadReport.bind( this )} type="button">*/}
                                {/*    <span> Refine Worklist </span>*/}
                                {/*</button>*/}

                            </h2>
                            </div>
                            
                        </header>
                            <main>
                                <Accordion
                                    accordionId="worklist-search-accordion"
                                    title="Basic Search"
                                    subTitle={this.accordionSecondaryText()}
                                    secondaryText={this.state.workListCount.basicSrcInpsCount
                                         === 0 ? 'None Selected' :
                                        `${this.state.workListCount.basicSrcInpsCount} Selected`}
                                    isExpanded={true}
                                >
                                    <div className="rows three-cols">
                                        <OptionsDropDown
                                            isPlaceholderTranslated={true}
                                            optionDisplayAttributes={['factoryDescription']}
                                            optionKey="factoryCode"
                                            options={options}
                                            label="Factory Code"
                                            onChange={this.updateFactoryCode.bind( this )}
                                            placeholder=""
                                            showPlaceholder={false}
                                            selectedValue={selectedValue}
                                        />
                                    </div>

                                    <div className="rows three-cols">
                                        <LabeledDateRangePicker
                                            to={this.state.searchInputs.processDate.to}
                                            from={this.state.searchInputs.processDate.from}
                                            onChange={this.handleRangeChange.bind( this )}
                                            className="process-date"
                                            name="processDate"
                                            label="Process Date"
                                        />
                                    </div>


                                    <div className="rows three-cols">
                                        <LabeledDateRangePicker
                                            to={this.state.searchInputs.buildDate.to}
                                            from={this.state.searchInputs.buildDate.from}
                                            onChange={this.handleRangeChange.bind( this )}
                                            className="build-date"
                                            name="buildDate"
                                            label="Build Date"
                                        />
                                    </div>


                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.pins,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="PIN"
                                                    name="pins"
                                                    isEditable={true}
                                                    label="PIN Number"
                                                    maxLength={17}
                                                    value={this.state.searchInputs.pins}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    onIconClick={this.initiatePopup.bind( this, 'pins' )}
                                                />
                                            </div>
                                        )}
                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.pins,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group pins edit-less">
                                                    <label>PIN Number</label>
                                                    <span className="asterisk-icon mandatory"><i className="fa fa-asterisk" /></span>
                                                    <div>
                                                        {' '}
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state.searchInputs.pins,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle"><button type="button" className="PIN" onClick={this.initiatePopup.bind( this, 'pins' )}> Edit Selection </button></span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.partNumber,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="Part"
                                                    name="partNumber"
                                                    isEditable={true}
                                                    label="Part Number"
                                                    maxLength={12}
                                                    value={this.state.searchInputs.partNumber}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    onIconClick={this.initiatePopup.bind( this, 'partNumber' )}
                                                />
                                            </div>
                                        )}
                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.partNumber,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group pipnumbers edit-less">
                                                    <label>Part Number</label>
                                                    <div>
                                                        {' '}
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state.searchInputs.partNumber,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle"><button type="button" className="Part" onClick={this.initiatePopup.bind( this, 'partNumber' )}> Edit Selection </button></span>
                                                            {' '}

                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    <div className="rows three-cols">
                                        <label className="region-search-label">Branch</label>
                                        <CSVMultiSelect
                                            options={this.state.branchDropdownList}
                                            value={this.state.searchInputs.branchIds}
                                            onChange={this.handleBranchChange}
                                            isMulti={true}
                                            menuPlacement="auto"
                                            maxMenuHeight={240}
                                        />
                                    </div>

                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.claimNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="Claim"
                                                    name="claimNumbers"
                                                    isEditable={true}
                                                    label="Claim Number"
                                                    maxLength={12}
                                                    value={this.state.searchInputs.claimNumbers}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    type="text"
                                                    onIconClick={this.initiatePopup.bind( this, 'claimNumbers' )}
                                                />
                                            </div>

                                        )}

                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.claimNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group claimnumbers edit-less">
                                                    <label>Claim Number</label>
                                                    <span className="asterisk-icon mandatory"><i className="fa fa-asterisk" /></span>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                // eslint-disable-next-line max-len
                                                                this.state.searchInputs.claimNumbers,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button type="button" className="Claim" onClick={this.initiatePopup.bind( this, 'claimNumbers' )}>
                                                                    Edit Selection
                                                                    {' '}
                                                                </button>
                                                            </span>
                                                            {' '}

                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    <div className="rows three-cols">
                                        <OptionsDropDown
                                            isPlaceholderTranslated={true}
                                            label="Audit Code"
                                            optionDisplayAttributes={['auditMessage']}
                                            optionKey="auditCode"
                                            options={this.state.auditCodeList}
                                            onChange={this.handleAuditCode}
                                            placeholder=""
                                            selectedValue={this.state.searchInputs.auditCode}
                                        />
                                    </div>


                                    {this.state.isPopupOpen && (

                                        <SimpleMultipleEntryPopup
                                            panelName={this.state.popupName}
                                            isOpen={this.state.isPopupOpen}
                                            onClose={this.onClosePopup}
                                            onUpdateProperty={this.updateMultiEntryInput.bind(
                                                this.props,
                                            )}
                                            propertyName={this.state.popupPropertyName}
                                            propertyValue={this.state.popupPropertyValue}
                                            onApplyValidate={this.validateMultiEntries.bind(
                                                this.props,
                                            )}
                                            validateEntry={this.validatePinOrPip.bind( this )}
                                            isValidEntry={this.state.isValidEntry}
                                            multiEntryValidation={this.multiEntryValidation
                                                .bind( this )}
                                        />
                                    )}

                                </Accordion>
                                <Accordion
                                    accordionId="product-search-accordion"
                                    title="Product Search"
                                    secondaryText={this.state.workListCount.prdSrcInpsCount === 0 ?
                                        'None Selected' :
                                        `${this.state.workListCount.prdSrcInpsCount} Selected`}
                                >

                                    <ProductSearch
                                        defaultProperties={this.state.searchInputs}
                                        onUpdateProperty={
                                            this.updateCurrentState.bind( this.props )
                                        }
                                    />
                                </Accordion>


                            </main>


                    </section>
                )}
                {this.state.isWorkListSearch && (
                    <div className={( this.state.isClaimDetails ? ' hide' : ' show' )}>
                        <WorkListResultPanel
                            workList={this.state.workListData}
                            searchViewOption={this.state.searchInputs.option}
                            onEditSearch={this.onEditSearch}
                            onNewSearch={this.onNewSearch}
                            onClaimDetails={this.onClaimDetails.bind( this )}
                            updateGridAPI={this.updateGridAPI.bind( this )}
                            editedInputs={this.state.modifiedSearch}
                            searchedLabels={this.getSearchedLabels}
                            selectedAuditCode={this.state.auditCodeList}
                            onSubmit={this.onSubmit}
                        />
                    </div>
                )}

                {this.state.isWorkListSearch && this.state.isClaimDetails && (


                    <div>
                        <ClaimDetailsPanel
                            warrantyClaimId={this.state.selectedWarrantyClaimID}
                            selectedClaimNumber={this.state.selectedClaimNumber}
                            claimDetailsInfo={this.state.claimDetailsInfo}
                            onBackToResult={this.onBackToResult}
                            getPreviousClaimDetails={this.getPreviousClaimDetails}
                            getNextClaimDetails={this.getNextClaimDetails}
                            callFrom="workList"
                        />
                    </div>
                )}
                <WorklistUploadPopup
                    isOpen={this.state.modelIsOpen}
                    onClose={this.onUploadReportClose.bind( this.props )}
                />
            </div>
        );

    }

}
Worklist.displayName = 'Worklist';
Worklist.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    reload: PropTypes.string.isRequired,
    updateReload: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( Worklist );
